export { fetchPublisherData } from 'next-flight-server-reference-proxy-loader?id=00d2caa75f1cf70ed3d5c9dbfac8cd2ade3f0b53b5&name=fetchPublisherData!'